var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdp-tpl-lightbox-portal" }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "pdp-tpl-lightbox",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.$emit("close")
              },
            },
          },
          [
            _c("div", { staticClass: "pdp-tpl-lightbox__inner" }, [
              _c(
                "button",
                {
                  ref: "closeBtn",
                  staticClass: "pdp-tpl-lightbox__close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("i", { staticClass: "bi bi-x-lg" })]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "pdp-tpl-lightbox__img",
                attrs: { src: _vm.template.thumbnail, alt: _vm.template.name },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-tpl-lightbox__actions" }, [
                !_vm.isSelected
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("select-template", _vm.template)
                          },
                        },
                      },
                      [_vm._v("\n          Add to selection\n        ")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-danger",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("deselect-template", _vm.template)
                          },
                        },
                      },
                      [_vm._v("\n          Remove from selection\n        ")]
                    ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }